import api from '../common/helpers/apiHelper';
import { IUserInitials } from '../common/models/user/IUserInitials';
import { IListData } from '../common/models/common/IListData';
import { IBaseFilter } from '../common/models/filter/IBaseFilter';
import { IUserSettingsFilter } from '../common/models/filter/IUserSettingsFilter';
import { mapSortToSortReq } from '../common/helpers/filterHelper';
import { IUpdateRoleData } from '../common/models/user/IUpdateRoleData';
import { IUpdateTeamData } from '../common/models/user/IUpdateTeamData';
import { ICreateUser } from '../common/models/user/ICreateUser';
import { UpdateProfile } from '../common/models/user/UpdateProfile';
import { ISearchUser } from '../common/models/user/ISearchUser';
import { ISettingsUsers } from '../common/models/settings/ISettingsUsers';
import { User } from '../common/models/user/User';
import { IUpdateStatusData } from '../common/models/user/IUpdateStatusData';

export const getOwners = (filter: IBaseFilter) => api.get<IListData<IUserInitials[]>>('/api/users', filter);

export const getUsers = (filter: IUserSettingsFilter) => api.get<ISettingsUsers>(
  '/api/users/all',
  { ...filter, sort: mapSortToSortReq(filter.sort) }
);

export const checkUserEmail = (payload: { email: string; checkMe?: boolean }) => api.get<{ isEmailUsed: boolean }>(
  '/api/users/email',
  payload
);

export const changeUsersStatus = (payload: IUpdateStatusData) => api.put<void>('/api/users/status', payload);

export const changeUsersRole = (payload: IUpdateRoleData) => api.put(
  '/api/users/role',
  payload
);

export const changeUsersTeam = (payload: IUpdateTeamData) => api.put(
  '/api/users/team',
  payload
);

export const createUser = (payload: ICreateUser) => api.post<User>(
  '/api/users',
  payload
);

export const updateProfile = (payload: UpdateProfile) => api.put(
  '/api/users/me',
  payload
);

export const searchUsers = (search: string) => api.get<ISearchUser[]>(
  '/api/users/search',
  { search }
);

export const resendInvite = (payload: { email: string }) => api.put(
  '/api/users/invite-resend',
  payload
);
